import api from '@/api/reconciliation';

const state = {
    // Yeni canlı veri
    liveSummary: [],
    liveOrderSummary: [],
    orderBreakdown: [],
    loading: false,
    
    // Eski veri (geriye dönük uyumluluk)
    summary: [],
    details: [],
    orderSummary: []
};

const getters = {
    // Yeni canlı veri getters
    liveSummary: state => state.liveSummary,
    liveOrderSummary: state => state.liveOrderSummary,
    orderBreakdown: state => state.orderBreakdown,
    loading: state => state.loading,
    
    // Eski getters (geriye dönük uyumluluk)
    summary: state => state.summary,
    details: state => state.details,
    orderSummary: state => state.orderSummary
};

const actions = {
    // Yeni canlı veri actions
    async fetchLiveSummary({ commit }, params) {
        commit('setLoading', true);
        try {
            const response = await api.getLiveSummary(params);
            commit('setLiveSummary', response.data);
        } catch (error) {
            console.error('Live summary fetch error:', error);
            commit('setLiveSummary', []);
        } finally {
            commit('setLoading', false);
        }
    },
    async fetchLiveOrderSummary({ commit }, params) {
        commit('setLoading', true);
        try {
            const response = await api.getLiveOrderSummary(params);
            commit('setLiveOrderSummary', response.data);
        } catch (error) {
            console.error('Live order summary fetch error:', error);
            commit('setLiveOrderSummary', []);
        } finally {
            commit('setLoading', false);
        }
    },
    async fetchOrderBreakdown({ commit }, params) {
        try {
            const response = await api.getOrderBreakdown(params);
            commit('setOrderBreakdown', response.data);
            return response.data;
        } catch (error) {
            console.error('Order breakdown fetch error:', error);
            commit('setOrderBreakdown', []);
            return [];
        }
    },
    async calculateOrderExpectedPayments({ commit }, params) {
        try {
            const response = await api.calculateOrderExpectedPayments(params);
            return response.status === 200 && response.data && response.data.success;
        } catch (error) {
            console.error('Calculate order expected payments error:', error);
            throw error;
        }
    },
    async recalculateAllExpectedPayments({ commit }, params) {
        try {
            const response = await api.recalculateAllExpectedPayments(params);
            return response.data;
        } catch (error) {
            console.error('Recalculate all expected payments error:', error);
            throw error;
        }
    },
    async fetchLiveTransactionDetails({ commit }, params) {
        commit('setLoading', true);
        try {
            const response = await api.getLiveTransactionDetails(params);
            commit('setDetails', response.data);
            return response.data;
        } catch (error) {
            console.error('Live transaction details fetch error:', error);
            commit('setDetails', []);
            return [];
        } finally {
            commit('setLoading', false);
        }
    },

    // Eski actions (geriye dönük uyumluluk)
    async fetchSummary({ commit }, params) {
        commit('setLoading', true);
        try {
            const response = await api.getSummary(params);
            commit('setSummary', response.data);
        } catch (error) {
            console.error('Reconciliation summary fetch error:', error);
            commit('setSummary', []);
        } finally {
            commit('setLoading', false);
        }
    },
    async fetchDetails({ commit }, params) {
        commit('setLoading', true);
        try {
            const response = await api.getDetails(params);
            commit('setDetails', response.data);
        } catch (error) {
            console.error('Reconciliation details fetch error:', error);
            commit('setDetails', []);
        } finally {
            commit('setLoading', false);
        }
    },
    async fetchOrderSummary({ commit }, params) {
        commit('setLoading', true);
        try {
            const response = await api.getOrderSummary(params);
            commit('setOrderSummary', response.data);
        } catch (error) {
            console.error('Reconciliation order summary fetch error:', error);
            commit('setOrderSummary', []);
        } finally {
            commit('setLoading', false);
        }
    },
    async calculateReconciliation({ commit }, params) {
        try {
            const response = await api.calculate(params);
            return response.status === 200 && response.data && response.data.success;
        } catch (error) {
            console.error('Reconciliation calculate error:', error);
            throw error;
        }
    }
};

const mutations = {
    // Yeni mutations
    setLiveSummary(state, data) {
        state.liveSummary = data;
    },
    setLiveOrderSummary(state, data) {
        state.liveOrderSummary = data;
    },
    setOrderBreakdown(state, data) {
        state.orderBreakdown = data;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    
    // Eski mutations (geriye dönük uyumluluk)
    setSummary(state, summary) {
        state.summary = summary;
    },
    setDetails(state, details) {
        state.details = details;
    },
    setOrderSummary(state, orderSummary) {
        state.orderSummary = orderSummary;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
